import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">

      <p class="poem-block mb-3">
        Oj, malsan’ terura venis, <br/>
        Mi pro timo tuj eksvenis! <br/>
        Oj, terura malsaneg’ – <br/>
        Ĉiuj tuj al ĉerkoj ek!
      </p>

      <p class="poem-block mb-3">
        Vi ne restu sen vakcino, <br/>
        Ĉar sen ĝi alvenos fino <br/>
        Al labor’ kaj al ripoz’. <br/>
        Agu laù l’ordon’ de VOZ!
      </p>

      <p class="poem-block mb-3">
        Sekvu vortojn de la mastroj <br/>
        Por ne trafu vin disastroj! <br/>
        Gardu lingvon de patruj’, <br/>
        Ĉar aliel velkos ‘uj’!
      </p>

      <p class="poem-block mb-3">
        Kantas ni en nia rondo <br/>
        En freneza nia mondo. <br/>
        Rido nepre savos nin, <br/>
        Estas justa la destin’!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Popolaj ŝtrofetoj (частушки)'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;






